import {
    DeleteOutlined,
    PaperClipOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import { Button, Divider } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';
import GlobalService from '../../../../services/Global.service';
import MyTaskService from '../../../../services/MyTask.service';
import usePermission from '../../../../hooks/usePermission';

export default function DSFormView({
    item,
    customize,
    setEditMode,
    imageFile,
    setImageFile,
    docFile,
    setDocFile,
    fileTask,
    setFileList,
    newStatus,
    getDSInformation,
}) {
    const ref = useRef();
    const notify = useNotify();
    let { tab, dsrTaskId } = useParams();
    const [applicantRole, setApplicantRole] = useState();
    const [deleteLoding, setDeleteLoding] = useState(false);
    const [openDelete, setOpenDelete] = useState({
        open: false,
        file: null,
    });
    const { t, i18n } = useTranslation();
    const [personalType, setPersonalType] = useState();
    const [requestType, setRequestType] = useState();

    const { isAuditor } = usePermission();

    const updateFileList = async (docList, imageList) => {
        const payload = {
            dsrTaskId: dsrTaskId,
            domainId: item?.domainId,
            applicantInformation: item?.applicantInformation,
            dataSubjectInformation: {
                dataSubjectTypeId:
                    item?.dataSubjectInformation?.dataSubjectTypeId, // บทบาทผู้ยื่นคำร้อง
                firstName: item?.dataSubjectInformation?.firstName, // ชื่อ
                lastName: item?.dataSubjectInformation?.lastName, // นามสกุล
                address: item?.dataSubjectInformation?.address, // ที่อยู่
                phone: item?.dataSubjectInformation?.phone, // เบอร์โทร
                email: item?.dataSubjectInformation?.email, // อีเมล
                cardId: item?.dataSubjectInformation?.cardId, // หมายเลขบัตรประจำตัวประชาชน
                staffId: item?.dataSubjectInformation?.staffId, // รหัสพนักงาน
                remark: item?.dataSubjectInformation?.remark, // รายละเอียดอื่นๆ (ถ้ามี)
            },
            detailsOfClaim: {
                purpose: item?.detailsOfClaim?.purpose,
                requestTypeId: item?.detailsOfClaim?.requestTypeId,
                personalLocation: item?.detailsOfClaim?.personalLocation,
                reason: item?.detailsOfClaim?.reason,
            },
            evidenceInformation: {
                filesDoc: docList,
                filesImage: imageList,
            },
        };
        try {
            await MyTaskService.editDSInformation(payload);
            getDSInformation();
        } catch (error) {}
    };

    useEffect(() => {
        async function getPersonalType(id) {
            if (id) {
                const { data } = await GlobalService.getDs();
                const dsTypeList = data?.resultData?.dataSubjectType;
                const dsType = dsTypeList?.filter((res) => res?.id === id)[0];
                setPersonalType(
                    i18n.language === 'en' ? dsType?.nameEn : dsType?.nameTh
                );
            }
            return null;
        }
        getPersonalType(item?.dataSubjectInformation?.dataSubjectTypeId);
    }, [i18n.language, item?.dataSubjectInformation?.dataSubjectTypeId]);

    useEffect(() => {
        setApplicantRole(item?.applicantInformation?.applicantRole);
    }, [item?.applicantInformation?.applicantRole]);

    useEffect(() => {
        async function getRequestType(id) {
            if (id) {
                const { data } = await GlobalService.getRequestType();
                const reqTypeList = data?.resultData;
                const reqType = reqTypeList?.filter(
                    (res) => res?.requestTypeId === id
                )[0];
                setRequestType(reqType.requestTypeShortName);
            }
            return null;
        }
        getRequestType(item?.detailsOfClaim?.requestTypeId);
    }, [item?.detailsOfClaim?.requestTypeId]);

    function formatPhoneNumber(phoneNumberString) {
        let phoneLength = phoneNumberString?.length;
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        let match =
            phoneLength === 9
                ? cleaned.match(/^(\d{2})(\d{3})(\d{4})$/)
                : cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match && phoneLength >= 9) {
            return match[1] + '-' + match[2] + '-' + match[3];
        } else {
            return phoneNumberString;
        }
    }

    const allowedType = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/msword', // .doc
        'application/pdf', // .pdf
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'image/png', // .png
        'image/jpeg', // .jepg
        'image/jpg', // .jepg
    ];

    const onChange = async (e) => {
        if (
            e.target.files.length &&
            e.target.files.length + fileTask.length <= 10
        ) {
            for (let i = 0; i < e.target.files.length; i++) {
                const fileSize = e.target.files[i].size / 1024 / 1024;
                const fileType = e.target.files[i].type;
                if (fileSize >= 2) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Upload error file size is wrong'),
                    });
                    return;
                }
                if (!allowedType.includes(fileType)) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Upload error file type is wrong'),
                    });
                    return;
                }
                // if (fileSize <= 10 && allowedType.includes(fileType)) {
                //     setValueInput(e.target.value);
                // }
            }
            const allowedTypeDoc = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                'application/msword', // .doc
                'application/pdf', // .pdf
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel', // .xls
            ];
            const allowedTypeImage = [
                'image/png', // .png
                'image/jpeg', // .jepg
                'image/jpg', // .jepg
            ];
            let bodyFormDocData = new FormData();
            let imageList = [];
            // let image = [];
            for (let i = 0; i < e.target.files.length; i++) {
                let ImageData = new FormData();
                const file = e.target.files[i];
                const fileType = file.type;
                ImageData.append('image', file);
                ImageData.append('fileName', file.name);
                ImageData.append('action', 'image-create-application');
                if (allowedTypeImage.includes(fileType)) {
                    try {
                        const { data } = await GlobalService.uploadImage(
                            ImageData
                        );
                        if (data?.resultData?.imageId) {
                            const item = {
                                fileStorageId: data.resultData?.imageId,
                                fileName: data.resultData?.imageName,
                                fileType: data.resultData?.imageType,
                            };
                            // image.push(data?.resultData);
                            imageList.push(item);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else if (allowedTypeDoc.includes(fileType)) {
                    const formfile = e.target.files[i];
                    const utf8Name = encodeURIComponent(formfile.name);
                    const header = `form-data; name="uploadFile"; filename*=UTF-8''${utf8Name}`;
                    bodyFormDocData.append('doc', formfile, header);
                    // bodyFormDocData.append('fileName', formfile?.name);
                }
            }
            setImageFile([...imageFile, ...imageList]);
            const docLength = Array.from(bodyFormDocData.keys()).length;
            let docFileList = [...docFile];
            let imageFileList = [...imageFile, ...imageList];
            if (docLength > 0) {
                bodyFormDocData.append('action', 'ds-request-step-4');
                try {
                    const { data } = await GlobalService.uploadDoc(
                        bodyFormDocData
                    );
                    if (data?.resultData) {
                        // setFileList([...fileTask, ...data?.resultData]);
                        setDocFile([...docFile, ...data?.resultData]);
                        docFileList = [...docFile, ...data?.resultData];
                        imageList = imageList.concat(...data?.resultData);
                    }
                } catch (error) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to uploaded'),
                    });
                    console.log(error);
                }
            }
            setFileList([...fileTask, ...imageList]);
            updateFileList(docFileList, imageFileList);
        }
    };

    const onInputClick = (event) => {
        event.target.value = '';
    };

    const downloadFile = async (file) => {
        const imageType = [
            'png', // .png
            'jpeg', // .jepg
            'jpg', // .jepg
        ];
        if (imageType.includes(file?.fileType)) {
            await GlobalService.getImage(file?.fileStorageId).then((res) => {
                const itemImg = `data:image/${file?.fileType};base64,${res?.data?.resultData?.imageId}`;
                // `data:image/png;base64,${data.resultData?.imageId}`
                if (res.data) {
                    const objectURL = itemImg;
                    const link = document.createElement('a');
                    link.href = objectURL;
                    link.download = file?.fileName + '.' + file.fileType;
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                }
            });
        } else {
            await GlobalService.downloadDoc(file?.fileStorageId).then((res) => {
                if (res.data) {
                    const objectURL = URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = objectURL;
                    link.download = file?.fileName + '.' + file.fileType;
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                }
            });
        }
    };

    const deleteFile = async (file) => {
        const imageType = [
            'png', // .png
            'jpeg', // .jepg
            'jpg', // .jepg
        ];
        const id = file?.fileStorageId;
        if (imageType.includes(file?.fileType)) {
            await GlobalService.deleteImage(id)
                .then((res) => {
                    setDeleteLoding(false);
                    if (res.data.resultCode === 1) {
                        setOpenDelete({
                            open: false,
                            file: null,
                        });
                        setImageFile(
                            imageFile.filter(
                                (file) => file.fileStorageId !== id
                            )
                        );
                        setFileList(
                            fileTask.filter((file) => file.fileStorageId !== id)
                        );
                    }
                })
                .catch((error) => {
                    setDeleteLoding(false);
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to deleted'),
                    });
                });
        } else {
            await GlobalService.deleteFile(id)
                .then((res) => {
                    setDeleteLoding(false);
                    if (res.data.resultCode === 1) {
                        setOpenDelete({
                            open: false,
                            file: null,
                        });
                        setDocFile(
                            docFile.filter((file) => file.fileStorageId !== id)
                        );
                        setFileList(
                            fileTask.filter((file) => file.fileStorageId !== id)
                        );
                    }
                })
                .catch((error) => {
                    setDeleteLoding(false);
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to deleted'),
                    });
                });
        }
    };

    return (
        <div>
            {newStatus && (
                <div
                    hidden={tab !== 'todolist'}
                    className="flex justify-end pb-2"
                >
                    <Button
                        disabled={isAuditor}
                        type="default"
                        size="large"
                        className="w-[120px] border-[#7B67FB] text-[#7B67FB]"
                        onClick={() => setEditMode(true)}
                    >
                        {t('common.Edit')}
                    </Button>
                </div>
            )}
            <div className="text-xl font-medium">
                {t('MyTask.DSInformation')}
            </div>
            <Divider className="my-2" />
            <div className="overflow-auto h-[70vh]">
                <div className="px-2 space-y-2 font-semibold ">
                    <div>
                        {t('MyTask.PetitionerRole')} :{' '}
                        <span className="font-normal">
                            {applicantRole === 0
                                ? t('MyTask.Role1')
                                : applicantRole === 1
                                ? t('MyTask.Role2')
                                : '-'}
                        </span>
                    </div>
                    {applicantRole === 1 && (
                        <div>
                            {t('MyTask.Purpose')} :{' '}
                            <div className="font-normal">
                                {item?.applicantInformation?.purpose || '-'}
                            </div>
                        </div>
                    )}
                    <div className="text-[#7B67FB]">
                        {t('MyTask.PetitionerInformation')}
                    </div>
                    <div>
                        {t('MyTask.NameLastname')} :{' '}
                        <span className="font-normal">
                            {`${item?.applicantInformation?.firstName} ${item?.applicantInformation?.lastName}`}
                        </span>
                    </div>
                    <div>
                        {t('MyTask.Phone')} :{' '}
                        <span className="font-normal">
                            {item?.applicantInformation?.phone
                                ? formatPhoneNumber(
                                      item?.applicantInformation?.phone
                                  )
                                : '-'}
                        </span>
                    </div>
                    <div>
                        {t('MyTask.Email')} :{' '}
                        <span className="font-normal">
                            {item?.applicantInformation?.email || '-'}
                        </span>
                    </div>
                    <div>
                        {t('MyTask.IdCard')} :{' '}
                        <span className="font-normal">
                            {item?.applicantInformation?.cardId || '-'}
                        </span>
                    </div>
                    <div>
                        {t('MyTask.Address')} :{' '}
                        <div className="font-normal">
                            {item?.applicantInformation?.address}
                        </div>
                    </div>
                    <div>
                        {t('MyTask.Remark')} :{' '}
                        <div className="font-normal">
                            {item?.applicantInformation?.remark || '-'}
                        </div>
                    </div>
                    <div className="text-[#7B67FB]">
                        {t('MyTask.PersonalDataSubjectInformation')}
                    </div>
                    <div>
                        {t('MyTask.DataSubjectType')} :{' '}
                        <span className="font-normal">
                            {item?.dataSubjectInformation?.dataSubjectTypeId
                                ? personalType
                                : '-'}
                        </span>
                    </div>
                    <div hidden={!customize?.display?.staffId}>
                        {t('MyTask.StaffID')} :{' '}
                        <span className="font-normal">
                            {item?.dataSubjectInformation?.staffId || '-'}
                        </span>
                    </div>
                    <div>
                        {t('MyTask.NameLastname')} :{' '}
                        <span className="font-normal">
                            {item?.dataSubjectInformation?.firstName
                                ? `${item?.dataSubjectInformation?.firstName} ${item?.dataSubjectInformation?.lastName}`
                                : '-'}
                        </span>
                    </div>
                    <div hidden={!customize?.display?.phone}>
                        {t('MyTask.Phone')} :{' '}
                        <span className="font-normal">
                            {item?.dataSubjectInformation?.phone
                                ? formatPhoneNumber(
                                      item?.dataSubjectInformation?.phone
                                  )
                                : '-'}
                        </span>
                    </div>
                    <div>
                        {t('MyTask.Email')} :{' '}
                        <span className="font-normal">
                            {item?.dataSubjectInformation?.email || '-'}
                        </span>
                    </div>
                    <div hidden={!customize?.display?.cardId}>
                        {t('MyTask.IdCard')} :{' '}
                        <span className="font-normal">
                            {item?.dataSubjectInformation?.cardId || '-'}
                        </span>
                    </div>
                    <div hidden={!customize?.display?.address}>
                        {t('MyTask.Address')} :{' '}
                        <div className="font-normal">
                            {item?.dataSubjectInformation?.address || '-'}
                        </div>
                    </div>
                    <div hidden={!customize?.display?.detail}>
                        {t('MyTask.Remark')} :{' '}
                        <div className="font-normal">
                            {item?.dataSubjectInformation?.remark || '-'}
                        </div>
                    </div>
                    <div className="text-[#7B67FB]">
                        {t('MyTask.DetailOfRequest')}
                    </div>
                    <div>
                        {t('MyTask.PersonalDataRequestedForRights')} :{' '}
                        <div className="font-normal whitespace-pre-line">
                            {item?.detailsOfClaim?.purpose || '-'}
                        </div>
                    </div>
                    <div>
                        {t('MyTask.RequestType')} :{' '}
                        <span className="font-normal">
                            {requestType || '-'}
                        </span>
                    </div>
                    <div hidden={!customize?.display?.personalLocation}>
                        {t('MyTask.PesonalDataLocation')} :{' '}
                        <div className="font-normal">
                            {item?.detailsOfClaim?.personalLocation || '-'}
                        </div>
                    </div>
                    <div>
                        {t(
                            'MyTask.DetailsOfRequestingRightsAndReasonsForRequesting'
                        )}{' '}
                        :{' '}
                        <div className="font-normal">
                            {item?.detailsOfClaim?.reason || '-'}
                        </div>
                    </div>
                    <div className="text-[#7B67FB]">
                        {t('MyTask.EvidenceInformation')}
                    </div>
                    <div>
                        {t('MyTask.ProofOfIdentity')} :{' '}
                        <div className="font-normal">
                            <ul
                                className="list-outside"
                                style={{ paddingInlineStart: '30px' }}
                            >
                                {item?.evidenceInformation?.proofOfIdentity.map(
                                    (res) => (
                                        <li
                                            key={res.id}
                                            hidden={
                                                res?.id ===
                                                '0ecb41743d7111edb8780242ac120002'
                                            }
                                            className="whitespace-pre-line"
                                        >
                                            {res?.name}
                                        </li>
                                    )
                                )}
                                {item?.evidenceInformation
                                    ?.proofOfIdentityAddon && (
                                    <li className="whitespace-pre-line">
                                        {
                                            item?.evidenceInformation
                                                ?.proofOfIdentityAddon
                                        }
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div>
                        {t('MyTask.Files')}
                        <div>
                            <div className="border-solid border border-blue-400 rounded-md min-h-[112px] px-2">
                                <button
                                    type="button"
                                    hidden={tab === 'request-done'}
                                    onClick={() => ref.current.click()}
                                    className={'cursor-pointer'}
                                >
                                    <Button
                                        hidden={!newStatus}
                                        className="mt-2 border-dashed border border-sky-300 text-sky-500 bg-sky-50 mb-2"
                                        icon={<PlusCircleOutlined />}
                                    >
                                        {t('MyTask.ChooseFile')}
                                    </Button>
                                    <input
                                        ref={ref}
                                        disabled={fileTask?.length === 10}
                                        onChange={onChange}
                                        onClick={onInputClick}
                                        type="file"
                                        style={{ display: 'none' }}
                                        multiple
                                        accept={allowedType.join(',')}
                                        // value={valueInput}
                                    />
                                </button>
                                <div className="py-2">
                                    {fileTask?.map((file, i) => {
                                        return (
                                            <div
                                                key={i}
                                                className="flex justify-between"
                                            >
                                                <button
                                                    type="button"
                                                    key={file.fileStorageId}
                                                    className="text-new space-x-2 cursor-pointer w-[95%] flex items-start"
                                                    onClick={() =>
                                                        downloadFile(file)
                                                    }
                                                >
                                                    <PaperClipOutlined className="pt-1" />
                                                    <div
                                                        className="overflow-hidden"
                                                        style={{
                                                            wordWrap:
                                                                'break-word',
                                                        }}
                                                    >
                                                        {file.fileName}.
                                                        {file.fileType}
                                                    </div>
                                                </button>
                                                {newStatus && (
                                                    <button
                                                        type="button"
                                                        hidden={
                                                            tab ===
                                                            'request-done'
                                                        }
                                                        onClick={() => {
                                                            setOpenDelete({
                                                                open: true,
                                                                file: file,
                                                            });
                                                        }}
                                                        className="text-[#95A0A8] cursor-pointer"
                                                    >
                                                        <DeleteOutlined />
                                                    </button>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="text-10 text-[#95A0A8] pt-1">
                                * {t('fileHinTitle')} <br />
                                {t('fileHinDes')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalDelete
                loading={deleteLoding}
                open={openDelete?.open}
                handelClose={() => {
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                }}
                handelOk={() => {
                    setDeleteLoding(true);
                    const file = openDelete.file;
                    deleteFile(file);
                }}
            />
        </div>
    );
}
